<template>
  <div class="page-log-in section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-6-tablet is-5-desktop is-4-widescreen">

          <div class="page-header">
            <h1 class="title is-3 mb-2">Login</h1>
          </div>

          <div class="box login-card">
            <form @submit.prevent="submitForm">
              <div class="field">
                <label class="label">Email</label>
                <div class="control has-icons-left">
                  <input
                    type="email"
                    class="input"
                    v-model="username"
                    autocomplete="email"
                    placeholder="Enter your email"
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-envelope"></i>
                  </span>
                </div>
              </div>

              <div class="field">
                <label class="label">Password</label>
                <div class="control has-icons-left">
                  <input
                    type="password"
                    class="input"
                    v-model="password"
                    autocomplete="current-password"
                    placeholder="Enter your password"
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
              </div>

              <div class="notification is-danger is-light" v-if="errors.length">
                <p
                  v-for="error in errors"
                  :key="error"
                  class="mb-1"
                >
                  {{ error }}
                </p>
              </div>

              <div class="field mt-5">
                <div class="control">
                  <button
                    class="button is-primary is-fullwidth"
                    type="submit"
                    :class="{ 'is-loading': isLoading }"
                    :disabled="isLoading"
                  >
                    Login
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginView',

  data() {
    return {
      username: '',
      password: '',
      errors: [],
      isLoading: false
    }
  },

  mounted() {
    document.title = 'Login | SCE Electrical'
  },

  methods: {
    async getUserData() {
      const response = await axios.get('/api/v1/me')

      this.$store.dispatch('setUser', response.data)

      this.$router.push('/jobs')
    },

    formatErrorMessage(property, message) {
      if (property === 'non_field_errors') {
        return Array.isArray(message) ? message[0] : message
      }

      const label = property.charAt(0).toUpperCase() + property.slice(1)

      return `${label}: ${Array.isArray(message) ? message[0] : message}`
    },

    async submitForm() {
      this.errors = []
      this.isLoading = true

      try {
        delete axios.defaults.headers.common.Authorization
        localStorage.removeItem('token')

        const formData = {
          username: this.username,
          password: this.password
        }

        const response = await axios.post('/api/v1/token/login/', formData)

        const token = response.data.auth_token

        this.$store.commit('setToken', token)

        axios.defaults.headers.common.Authorization = `Token ${token}`

        await this.getUserData()
      } catch (error) {
        if (error.response) {
          for (const property in error.response.data) {
            this.errors.push(
              this.formatErrorMessage(property, error.response.data[property])
            )
          }
        } else {
          this.errors.push('Something went wrong. Please try again.')
          console.log(error)
        }
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.page-log-in {
  min-height: 100%;
}

.page-header {
  margin-bottom: 1.5rem;
}

.login-card {
  border-radius: 12px;
  padding: 1.5rem;
}

.notification p:last-child {
  margin-bottom: 0 !important;
}
</style>